import { Address, Phone } from "@smart/bridge-smokeball-basic";
import { Country } from "@smart/bridge-types-basic";

export const formatPhoneNumber = (phoneNumber: Phone | null | undefined) => {
  if (!phoneNumber) return "";
  const areaCode = phoneNumber.areaCode ? `(${phoneNumber.areaCode}) ` : "";
  return `${areaCode}${phoneNumber.number || ""}`;
};

export const formatAddressLine = (address: Address, country: Country) => {
  switch (country) {
    case "AU":
      return [
        [
          [address.unitNumber, address.streetNumber].filter(Boolean).join("/"),
          address.streetName,
          address.streetType,
        ]
          .filter(Boolean)
          .join(" "),
        [address.city, address.zipCode].filter(Boolean).join(" "),
        [address.state, address.country].filter(Boolean).join(", "),
      ]
        .filter(Boolean)
        .join(", ");
    case "US":
      return [
        address.addressLine1,
        address.addressLine2,
        address.county,
        address.city,
        address.zipCode,
        address.state,
        address.country,
      ]
        .filter(Boolean)
        .join(", ");
    case "GB":
      return [
        [
          [address.unitNumber, address.streetNumber].filter(Boolean).join("/"),
          address.streetName,
        ]
          .filter(Boolean)
          .join(" "),
        address.locality,
        address.city,
        [address.county, address.zipCode].filter(Boolean).join(" "),
        [address.state, address.country].filter(Boolean).join(", "),
      ]
        .filter(Boolean)
        .join(", ");
    default:
      return "";
  }
};
